module.exports = __webpack_public_path__ + "media/images/guideline/C01-fbf1285932ef1c2a1a2d3cb8d608008a.jpg";